import { inject, injectable } from 'inversify'

import { InjectionTokens } from '@/controller/tokens'

import { UseCase } from '@/domain/core/UseCase'
import { Result } from '@/domain/protocols/Result'

import type { IUserChartRepository } from '@/data/UserChartRepository/IUserChartRepository'

@injectable()
export class DeleteUserChartsLocalDataUseCase implements UseCase<void, Promise<Result<void>>> {
  constructor(@inject(InjectionTokens.UserChartRepository) private repository: IUserChartRepository) {}

  async execute(): Promise<Result<void>> {
    this.repository.clearLocalData()
    return Result.ok()
  }
}
